import { Flex, FlexProps } from '@modusign/design-system';

interface ResourceModalBodyProps extends FlexProps<'div'> {}

const ResourceModalBody = (props: ResourceModalBodyProps) => {
  return <Flex flexDirection="column" px={[6, 8]} py={8} width="100%" {...props} />;
};

export default ResourceModalBody;
